import gql from 'graphql-tag';

import { address, officePlace } from '../fragments';

export const getOfficePlaceById = gql`
    query GetOfficePlaceById($placeId: Int!, $officeId: Int!) {
        officePlaceById(placeId: $placeId, officeId: $officeId) {
            ...OfficePlaceFragment
            address {
                ...AddressFragment
            }
        }
    }
    ${officePlace}
    ${address}
`;

export const getPlacesByOfficeId = gql`
    query GetPlacesByOfficeId($officeId: Int!, $filters: PlacesByOfficeFiltersInput) {
        placesByOfficeId(officeId: $officeId, filters: $filters) {
            ...OfficePlaceFragment
            address {
                ...AddressFragment
            }
        }
    }
    ${officePlace}
    ${address}
`;
